import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ModalConfig} from '../../../model/modal-config';
import {PageNames} from '../../../shared/page-names.enum';
import {NavigationService} from '../../../services/navigation/navigation.service';
import {Error} from '../../../model/error';

@Component({
  selector: 'app-order-failed',
  templateUrl: './order-failed.component.html',
  styleUrls: ['./order-failed.component.less']
})
export class OrderFailedComponent implements OnInit, AfterViewInit {

  static FAILED = 'eos-tv-shop-ii.text.order-failed';
  static REACH_CHECK_FAILED = 'eos-tv-shop-ii.text.order-reach-check-description';
  static STREAMING_BUNDLE_WAITING_ACTIVATION = 'eos-tv-shop-ii.text.streaming-bundle-waiting-activation';
  static PENDING = 'eos-tv-shop-ii.text.order-is-pending';
  @Output()
  emitOnBack = new EventEmitter<Object>();
  @Input()
  config: ModalConfig;

  @Input()
  error: Error;
  @Output()
  emitCloseOrderFailed = new EventEmitter<Object>();
  componentName = PageNames.ORDERING_FAILED;
  label: string;

  constructor(protected navigationService: NavigationService, protected changeDetector: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.setLabel(this.error);
  }

  ngAfterViewInit(): void {
    this.navigationService.resetNavigation();
    this.changeDetector.detectChanges();
  }

  public onEmitCloseOrderFailed(): void {
    this.emitCloseOrderFailed.emit(true);
  }

  onBack(): void {
    this.emitOnBack.emit({
      value: true
    });
  }

  setLabel(error: Error): void {
    if (error.isOrderPending()) {
      this.label = OrderFailedComponent.PENDING;
    } else if (error.isReachCheckFailed()) {
      this.label = OrderFailedComponent.REACH_CHECK_FAILED;
    } else if (error.isWaitingActivation()) {
      this.label = OrderFailedComponent.STREAMING_BUNDLE_WAITING_ACTIVATION;
    } else {
      this.label = OrderFailedComponent.FAILED;
    }
  }

}
